import Phaser from 'phaser';
import type { OutfitSlot } from '../types';

/**
 * 현재 equipped 상태 → 사용할 캐릭터 텍스처 키.
 * char_full_<hairId> 가 로드돼 있으면 그걸, 아니면 character_bald.
 */
export function getCharacterTextureKey(
  scene: Phaser.Scene,
  equippedIds: Partial<Record<OutfitSlot, string>>
): string {
  const hairId = equippedIds.hair;
  if (hairId) {
    const k = `char_full_${hairId}`;
    if (scene.textures.exists(k)) return k;
  }
  return 'character_bald';
}
